import styled from 'styled-components';

const Body = styled.div`
  font-family: 'Work Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 1.1em;
  color: white;
  margin: auto;
  max-width: 38em;
`;

export default Body;



// WEBPACK FOOTER //
// ./client/components/shared/Body/index.js